import StatisticsRow from './Row'

export default StatisticsRow
